import { Flex } from '@chakra-ui/react';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import Header from '@pages/UploadSellout/components/convert/header';
import SelloutInformation from '@pages/UploadSellout/components/convert/information';
import ProductList from '@pages/UploadSellout/components/convert/product-list';
import SkuUpsertModal from '@pages/UploadSellout/components/skuUpsertModal';
import PopUpNotification from '@pages/UploadSellout/components/popUpNotification';

import { useDataKonversi } from '@pages/UploadSellout/hooks/state/useDataKonversi';

const Konversi = () => {
    const { data } = useDataKonversi();
    const navigate = useNavigate();

    useEffect(() => {
        if (!data?.success_data?.length && !data?.failed_data?.length) {
            // navigate('/upload-sellout', { replace: true });
        }
    }, []);

    return (
        <Flex flexDirection="column" gap="24px">
            <PopUpNotification />
            <SkuUpsertModal />
            <Header />
            <SelloutInformation />
            <ProductList />
        </Flex>
    );
};

export default Konversi;
